module.exports = __webpack_public_path__ + "img/home-index-menu8.4f476063.png";